window.VegasBG = {
	init: ($container) => {
		if (!$container) {
			$container = $('body');
		}

		let $bg = $container.find('[data-bg]'),
			$color = $container.find('[data-color]');

		if ($bg.length) {
			VegasBG.bg($bg);
		}

		if ($color.length) {
			VegasBG.color($color);
		}
	},

	bg: function ($bg) {
		$bg.each(function () {
			let $self = $(this),
				bg = $self.data('bg'),
				repeat = $self.data('repeat') || 'no-repeat',
				position = $self.data('position') || 'center',
				size = $self.data('size') || 'cover',
				attachment = $self.data('attachment') || 'inherit',
				overlay = $self.data('overlay') || false;

			$self.css({
				'background-image': 'url(' + bg + ')',
				'background-position': position,
				'background-repeat': repeat,
				'background-size': size,
				'background-attachment': attachment,
				'position': 'relative',
				'z-index': 0
			});

			if (overlay && overlay !== '') {
				$self.prepend('<div class="vg-bg-overlay"></div>');
				let $overlay = $self.find('.vg-bg-overlay'),
					overlayColor = $self.data('overlaycolor') || '#000000';

				$overlay.css({
					'position': 'absolute',
					'z-index': 1,
					'width': '100%',
					'height': '100%',
					'top': 0,
					'left': 0,
					'background': VegasBG.hexToRgbA(overlayColor, (overlay / 100))
				});
			}
		});
	},

	color: function ($color) {
		$color.each(function () {
			let $self = $(this),
				color = $self.data('color'),
				overlay = $self.data('color-opacity') || 100;

			$self.css({
				'background-color': VegasBG.hexToRgbA(color, (overlay / 100))
			});
		});
	},

	hexToRgbA: (hex, opacity = 1) => {
		let c;

		if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
			c = hex.substring(1).split('');
			if (c.length === 3) {
				c = [c[0], c[0], c[1], c[1], c[2], c[2]];
			}
			c = '0x' + c.join('');
			return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + opacity + ')';
		}
	}
};

$(document).ready(function () {
	VegasBG.init();
});
